interface SpeakerIconProps {
  className?: string;
}

/**
 * SpeakerIcon — inline single-color ink speaker glyph for replay buttons
 * (फिर सुनो). Drawn in `currentColor` strokes so it takes the button's ink
 * (and its hover rubrication) like the ✓/✗/❋/→ dingbats do; sized in `em`
 * so it scales with the label text. Same flat-ink approach as the
 * pen-nib glyph on the paper-dictation intro card. No gradients, no
 * OS-rendered color emoji.
 */
export function SpeakerIcon({ className = "" }: SpeakerIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      aria-hidden="true"
      focusable="false"
      className={`inline-block align-[-0.125em] ${className}`}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      {/* Speaker body: box + cone, one closed outline. */}
      <path d="M4 9.5h3.5L13 5v14l-5.5-4.5H4z" />
      {/* Single quiet sound arc — manuscript-restrained, not a broadcast. */}
      <path d="M16.5 9.5a3.8 3.8 0 0 1 0 5" />
    </svg>
  );
}
